import { RESOURCES_INBOX_ITEM } from 'src/constants/resources';
import { useSearch } from 'src/hooks/common';

import { useResourceList } from './useResourceList';

export const useResourcesInboxItem = (skip?: boolean) => {
  const { searchValue } = useSearch();
  const shouldSkip = skip || !!searchValue;
  const { resourcesCount, loading } = useResourceList(shouldSkip);

  const hasResourcesInboxItem = resourcesCount > 0;

  return {
    resourcesInboxItem: RESOURCES_INBOX_ITEM,
    hasResourcesInboxItem,
    loading,
  };
};
